import React, { useState, useEffect } from "react";
// import { MultiSelect } from "primereact/multiselect";
// import "primereact/resources/primereact.css";
// import "primereact/resources/themes/saga-blue/theme.css";
// import { Dropdown } from "primereact/dropdown";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import axios from "axios";
//import { Apis } from "../../Apis/Apis";
//import Alert from "react-bootstrap/Alert";
import Data from "../../Data/data.json";
import "./css/Fcontact.css";
import { toast, ToastContainer } from "react-toastify";
import { useIsOnline } from "react-use-is-online";
// import ReCAPTCHA from "react-google-recaptcha-v3";
import useFirstRender from "../../hooks/useFirstRender";
import useGeoLocation from "react-ipgeolocation";
import Dynamic_data from "../../Data/Data";
import { useNavigate } from "react-router-dom";
import CountryData from "country-data";
import Cookies from "js-cookie";

// Multi Select feature - Starts Here
import Select, { components } from "react-select";
import Option from "./Option";
import MySelect from "./MySelect";
import MultiValue from "./MultiValue";
import makeAnimated from "react-select/animated";
const animatedComponents = makeAnimated();
// Multi Select feature - Ends Here

const Fcontact = ({ policy, onSubmit }) => {
  const firstRender = useFirstRender();
  const [selectedInterest, setSelectedIntrest] = useState(null);
  const [selectedEmployeeSize, setSelectedEmployeeSize] = useState(null);
  const [count, setCount] = useState(false);
  const { isOnline, isOffline, error } = useIsOnline();
  const location = useGeoLocation();
  const [phone, setPhone] = useState("");
  const [state, setState] = useState({
    show: false,
    errorList: null,
    emailCheck: true,
  });
  var SITE_KEY = Dynamic_data?.Site_key;
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const navigate = useNavigate();
  let get_cookies_value = Cookies.get("cuvid");

  const emailFormet = Data?.emailFormet;
  const cities = Data?.EmployeeSize;
  const Intrest = Data?.IntrestIn;
  const current_country = String(location.country).toLowerCase();
  let change_to_Upper = current_country.toUpperCase();
  let formate_contry = CountryData.countries[change_to_Upper];
  let GetContryCode = formate_contry && formate_contry?.countryCallingCodes[0];
  // console;
  // console.log("sdsdsd=======><><", GetContryCode);

  const handleOnClick = (e) => {
    e.preventDefault();
    if (isOnline) {
      setLoading(true);
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(SITE_KEY, { action: "submit" })
          .then((token) => {
            SubmitForm(e, token);
          });
      });
    } else if (isOffline) {
      setLoading(false);
      setCount(true);
      setTimeout(() => {
        setCount(false);
      }, 3000);
    }
  };

  useEffect(() => {
    if (firstRender) {
      return;
    }
    window.location.reload();
  }, [isOnline]);

  // console.log("cooooooo", isOnline);

  const SubmitForm = async (e, token) => {
    let str = "";
    selectedInterest?.map((element, index) => {
      if (selectedInterest?.length - 1 !== index) {
        str += element?.name + ",";
      } else {
        str += element?.name;
      }
    });

    if (str == "") {
      let errorList = [];
      errorList.push("Area Of Interest is required.");
      setState((pre) => ({ ...pre, errorList: errorList }));
      setLoading(false);
      return;
    }

    let data = {
      FirstName: e?.target?.First_Name?.value,
      LastName: e?.target?.Last_Name?.value,
      Organization: e?.target?.Organization?.value,
      JobTitle: e?.target?.Job_title?.value,
      EmployeeSize: selectedEmployeeSize?.name,
      WorkEmail: e?.target?.Email?.value,
      PhoneNumber: phone,
      AreaOfInterest: str,
      Message: e?.target?.message?.value,
      // AcceptUserConsent: e?.target?.policy?.value
      //   ? e?.target?.policy?.value
      //   : true,
      AcceptUserConsent: e?.target?.policy?.value == "on" ? true : false,
      gRecaptchaResponse: token,
      "request-from": "footer",
    };

    if (state?.emailCheck) {
      let result = await axios({
        method: "post",
        url: Dynamic_data?.Apis_Url?.SubmitForm,
        data: data,
      });

      console.log("form submit result => ", result);
      if (result?.data?.Result) {
        e.target.First_Name.value = "";
        e.target.Last_Name.value = "";
        e.target.Organization.value = "";
        e.target.Job_title.value = "";
        e.target.Email.value = "";
        e.target.message.value = "";
        setSelectedIntrest(null);
        setSelectedEmployeeSize(null);
        setPhone(GetContryCode);
        setLoading(false);
        setState((pre) => ({ ...pre, show: false }));
        if (onSubmit) {
          console.log("inside onSubmit block ");
          onSubmit();
        }
        console.log("navigate to thank you => ");
        navigate("/thank-you");
      } else {
        // console.log("form submit error => ");
        setLoading(false);
        setState((pre) => ({ ...pre, errorList: result?.data?.ErrorList }));
      }
    } else {
      setState((pre) => ({ ...pre, show: false }));
      e.target.First_Name.value = "";
      e.target.Last_Name.value = "";
      e.target.Organization.value = "";
      e.target.Job_title.value = "";
      e.target.Email.value = "";
      e.target.message.value = "";
      setSelectedIntrest(null);
      setSelectedEmployeeSize(null);
      setPhone(GetContryCode);
      setLoading(false);
      if (onSubmit) {
        console.log("inside onSubmit block ");
        onSubmit();
      }
      navigate("/thank-you");
    }
  };

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
      if (isScriptExist && callback) callback();
    };

    // Initialize Google Re-Captcha after 5 Seconds
    let timer = setTimeout(function () {
      // load the script by passing the URL
      loadScriptByURL(
        "recaptcha-key",
        `${Data?.googlePath}${SITE_KEY}`,
        function () {},
      );
    }, 5000);

    // Clear the timer after initializing Google Re-Captcha
    return () => clearTimeout(timer);
  }, []);

  // Multi Select feature - Starts Here
  let InterestOptions = Intrest.map((obj) => {
    var info = {
      name: obj.name,
      value: obj.name,
      label: obj.name,
    };
    return info;
  });

  if (selectedInterest) {
    let selectedVals = selectedInterest.map((x) => x.value);
    // let hiddenOptions = selectedVals.length > 1 ? selectedVals.slice( 0, 3 ) : [];
    let hiddenOptions = [];
    InterestOptions = InterestOptions.filter(
      (x) => !hiddenOptions.includes(x.value),
    );
  }

  let myCustomMultiSelectStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      border: 0,
      boxShadow: "none",
      minHeight: "36px",
    }),
    menu: (baseStyles, state) => ({
      ...baseStyles,
      left: 0,
      height: "200px",
    }),
    menuList: (baseStyles, state) => ({
      ...baseStyles,
      height: "200px",
    }),
    container: (baseStyles, state) => ({
      ...baseStyles,
      padding: "6px 2px !important",
    }),
    multiValue: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: "#effcff",
      borderRadius: "4px",
    }),
  };
  // Multi Select feature - Ends Here

  return (
    <section id="getStrated" className="getStratedForm">
      <div className="container">
        <div className="col-md-12 col-lg-12 text-center contact-head">
          <h2 className="h1">Get Started</h2>
        </div>
        <div className="row">
          <div className="col-md-12 col-lg-12">
            <div className="getStartedForm-wrapper">
              <div className="row justify-content-center">
                <div className="col-lg-8 form-center">
                  <form onSubmit={(e) => handleOnClick(e)}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="*First Name:"
                          name="First_Name"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="*Last Name:"
                          name="Last_Name"
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <input
                          type="email"
                          className={
                            state?.emailCheck
                              ? "form-control"
                              : "form-control form-control-1"
                          }
                          placeholder="*Work Email:"
                          name="Email"
                          onChange={(e) => {
                            let value = e?.target?.value;
                            for (let i = 0; i < emailFormet.length; i++) {
                              if (value.includes(emailFormet[i])) {
                                setState((pre) => ({
                                  ...pre,
                                  emailCheck: false,
                                }));
                                break;
                              } else {
                                setState((pre) => ({
                                  ...pre,
                                  emailCheck: true,
                                }));
                              }
                            }
                          }}
                          required
                        />
                      </div>
                      {!state?.emailCheck ? (
                        <label style={{ color: "red" }}>
                          This is not a Work email
                        </label>
                      ) : null}
                      <div className="col-md-12">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="*Organization:"
                          name="Organization"
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="card flex justify-content-center">
                          {/*<Dropdown
                            value={selectedEmployeeSize}
                            onChange={(e) => setSelectedEmployeeSize(e.value)}
                            options={cities}
                            optionLabel="name"
                            showClear
                            placeholder="Employee Size:"
                            className="w-full md:w-14rem"
                          />*/}

                          <select
                            value={selectedEmployeeSize ?? ""}
                            onChange={(e) =>
                              setSelectedEmployeeSize(e.target.value)
                            }
                            className="form-control"
                          >
                            <option value="">Employee Size</option>
                            {cities.map((e, key) => {
                              return (
                                <option key={key} value={key}>
                                  {e.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        {/* <input type="text" className="form-control" placeholder="Employee Size:"
                                                    name="Organization" /> */}
                      </div>
                      <div className="col-md-6">
                        <PhoneInput
                          country={current_country}
                          enableSearch={true}
                          value={phone}
                          onChange={(phon) => setPhone(phon)}
                          required
                        />
                        {/* <input type="text" className="form-control" placeholder="Phone:"
                                                    name="Phone" required /> */}
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="*Job Title:"
                          name="Job_title"
                          required
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="card flex justify-content-center">
                          {/*<MultiSelect
                            value={selectedInterest}
                            onChange={(e) => setSelectedIntrest(e.value)}
                            selectAll={false}
                            options={Intrest}
                            optionLabel="name"
                            placeholder="*Area of Interest"
                            maxSelectedLabels={3}
                            className="form-control"
                            required
                          />*/}

                          {/*<select value={selectedInterest??''} onChange={(e) => setSelectedIntrest(e.target.value)} className="form-control" required>
                            <option value="">*Area of Interest</option>
                            {Intrest.map((e, key) => {
                                return <option key={key} value={key}>{e.name}</option>;
                            })}
                          </select>*/}

                          {/*** Multi Select feature - Starts Here  ***/}
                          {/*<Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={InterestOptions}
                            onChange={(e) => setSelectedIntrest(e)}
                            value={selectedInterest}
                            components={{ MultiValue }}
                            className="form-control"
                          />*/}

                          <MySelect
                            closeMenuOnSelect={false}
                            isMulti
                            options={InterestOptions}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                              MultiValue,
                              animatedComponents,
                            }}
                            onChange={(e) => setSelectedIntrest(e)}
                            allowSelectAll={true}
                            value={selectedInterest}
                            className="form-control"
                            styles={myCustomMultiSelectStyle}
                          />
                          {/*** Multi Select feature - Ends Here  ***/}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <textarea
                          name="message"
                          placeholder="Message:"
                          className="form-control"
                        ></textarea>
                      </div>
                      {policy ? (
                        <div className="col-md-12">
                          <div className="agreement-txt">
                            <input type="checkbox" name="policy" required />
                            <label>
                              &nbsp; I agree to the*{" "}
                              <a
                                href="https://www.beyondkey.com/privacy-policy"
                                target="_blank"
                              >
                                Privacy Policy
                              </a>
                            </label>
                          </div>
                        </div>
                      ) : null}
                      {state?.show ? (
                        <div>
                          <p>Thank You</p>
                        </div>
                      ) : (
                        state?.errorList?.map((err) => (
                          <label className="errorbox">{err}</label>
                        ))
                      )}
                      {count == true ? (
                        <label>You need to be online for submit form</label>
                      ) : null}
                      {loading ? (
                        <label>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </label>
                      ) : null}
                      <div className="col-md-12"></div>
                      <div className="col-12">
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <button
                              data-res=""
                              type="submit"
                              className="rc-primary-btn rc-large-btn rc-btn "
                            >
                              Request a Demo
                            </button>
                          </div>
                          {response && (
                            <label>
                              Output:
                              <br />
                              <pre>
                                {JSON.stringify(response, undefined, 2)}
                              </pre>
                            </label>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};
export default Fcontact;
